import { Point } from './coreTypes';


export const equal = (a: Point, b: Point) => a.x === b.x && a.y === b.y;
export const getDist = (a: Point, b: Point) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);


export const clamp = (val: number, lower?: number, upper?: number) => {
  if (lower !== undefined)
    val = Math.max(lower, val);
  if (upper !== undefined)
    val = Math.min(val, upper);
  return val;
};


export const throttle = <TArgs extends any[]>(callback: (...args: TArgs) => void, ms: number) => {
  if (ms <= 0)
    return callback;
  
  let lastArgs: TArgs | null = null;
  let timeout: NodeJS.Timeout | null = null;
  
  const invoke = (...args: TArgs) => {
    if (timeout === null) {
      callback(...args);
      timeout = setTimeout(() => {
        timeout = null;
        if (lastArgs !== null) {
          invoke(...lastArgs);
          lastArgs = null;
        }
      }, ms);
    } else {
      lastArgs = args;
    }
  };
  return invoke;
};